import {Fragment} from "react";
import {useTranslation} from "react-i18next";
import {useArticles} from "../hooks/use-articles";

import Header from "../сomponents/section/Header/Header";
import PageHeader from "../сomponents/UI/header/PageHeader";
import SectionHeaderSmall from "../сomponents/UI/header/SectionHeaderSmall";
import NewsShowcase from "../сomponents/section/NewsShowcase";
import Ball from "../сomponents/Ball";
import Container from "../сomponents/UI/Container";
import ContentLoadingSpinner from "../сomponents/UI/loading/ContentLoadingSpinner";

const Newsroom = () => {
    const { t } = useTranslation();
    const articles = useArticles();

    let articlesCards = <ContentLoadingSpinner />;
    if (articles.length > 0) {
        articlesCards = <NewsShowcase newsInfo={articles} />;
    }

    return (
        <Fragment>
            <Header home={false} />
            <main className="overflow-hidden position-relative">
                <PageHeader>
                    {t("newsroom.pageHeader")}
                </PageHeader>
                <Container>
                    <SectionHeaderSmall>{t("newsroom.galleryName")}</SectionHeaderSmall>
                    {articlesCards}
                </Container>
                <Ball
                    width='600px'
                    height='600px'
                    top='35%'
                    right='35%'
                    color='#00FFC238'
                />
                <Ball
                    width='800px'
                    height='800px'
                    top='70%'
                    left='10%'
                    color='#050A22'
                />
            </main>
        </Fragment>
    );
};

export default Newsroom;